import { render, staticRenderFns } from "./TemplateFileDetail.vue?vue&type=template&id=6e6e0ce0&"
import script from "./TemplateFileDetail.vue?vue&type=script&lang=js&"
export * from "./TemplateFileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports